export default __webpack_public_path__ + "static/media/predict.81b23155.jpeg";